import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import SideBarLeftPanel from "./SideBarLeftPanel";
import SideBarLeftTopContent from "./SideBarLeftTopContent";
import ValueContext from "../../ContextAPi/appContext";
import { toast } from "react-toastify";
import ModuleCardsWindow from "./ModuleCardsWindow";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import { expandClaims, getChildModules, getSaveAssets } from "../../services/apis";
import ModulesModal from "../Editor/ModulesModal";
import AssociatedModules from "./AssociatedModules";
const LeftPanel = (props) => {
  const {
    showBannertype,
    setModules,
    modules,
    showAssettype,
    openTextWindow,
    setOpenTextWindow,
    getLayerDetails,
    layerCompData,
    setLayerCompData,
    openShapesWindow,
    setOpenShapesWindow,
    setOpenTimeLine,
    openTimeLine,
    setOpenModuleWindow,
    openModuleWindow,
    sendAtomDetails2Canvas,
    setOpenImageWindow,
    openImageWindow,
    selectedComponent,
    setSelectedComponent,
    layerId,
    imageOnCanvas,
    toggleAnimatedBanner,
    playPause,
    linkedModulesType,
    setLinkedModulesType,
    loadingModules,
    setLoadingModules,
    setVeevaModuleCardData,
    veevaModuleCardData,
    playPauseRef,
    toggleHideComp,
    toggleLockComp,
    setMultiSelectedComps,
    openModulesModal,
    setOpenModulesModal,
    openModulesScreen,
    setOpenModulesScreen,
    showModulesSection,
    setShowModulesSection,
    setIsNext,
    isNext,
    isModuleExist,
    getEditSaveAssets,
    bannerId,
    setModuleCardsDataLHS,
    moduleCardsDataLHS,
    setSelectedModulecards,
    selectedModulecards,
    setModuleSearchExpression,
    moduleSearchExpression,
    isImageDropped,
    setIsImageDropped,
    isReferenceFootnotes,
    isReferenceFootnotesScrollbar,
    editComponent,
    setDataGraphichImgDropped,
    dataGraphichImgDropped,
    moduleClaimsData,
    setModuleClaimsData,
    droppedComponentIds,
    droppedTextIds,
    droppedTitleIds,
    setDroppedTitleIds,
    claimsArray,
    reusableTextIdsArray,
    setDroppedTextIds,
    setDroppedComponentIds,
    setClaimReferencesFoonotes,
    setDroppedComponentTextIds,
    setScrollClaimReferencesFoonotes,
    setClaimsArray,
    setEditModuleClicked,
    notUsedEditorToggle,
    setNotUsedEditorToggle,
    deleteModulesOnCanvas,
    setUndoVersion,
    undoVersion,
    undoStack,
    redoStack,
    setRemoveSymbol,
    moduleStatuses,
    setModuleStatuses,
    setState,
    setBannerValidationCheck,
    allMustUseDataEmpty,
    isOneTimeAsset,
  } = props;
  const { classes } = props;
  const [linkImages, setLinkImages] = useState([]);
  const linkImagesRequestRef = useRef(0);
  const appData = useContext(ValueContext);
  const [imageCount, setImageCount] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [bgClass, setBgClass] = useState(true);
  const [selectedModule, setSelectedModule] = useState(undefined);
  const [associatedCards, setAssociatedCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noBussinessRules, setNoBussinessRules] = useState(false);
  const [selectedChecked, setSelectedChecked] = useState(false);
  const [expandModule, setExpandModule] = useState([]);
  const usedModuleIds = useMemo(
    () => ({
      claimsArray,
      reusableTextIdsArray,
      droppedComponentIds,
      droppedTextIds,
      droppedTitleIds,
      notUsedEditorToggle,
    }),
    [
      claimsArray,
      reusableTextIdsArray,
      droppedComponentIds,
      droppedTextIds,
      droppedTitleIds,
      notUsedEditorToggle,
    ],
  );
  useEffect(() => {
    if (selectedModule && !selectedModule?.ruleCondition) {
      handleExpandModuleClaims(selectedModule, "parentModule");
    } else if (
      selectedModule &&
      selectedModule?.ruleCondition === "MustExistWith"
    ) {
      handleExpandModuleClaims(selectedModule, "childModule");
    }
    if(appData.moduleExpired){
       appData.setModuleExpired(false);
    }
  }, [usedModuleIds,appData.moduleExpired]);

  const [mlrStatuses, setMlrstatuses] = useState([]);
  const [openElements, setOpenElements] = useState({
    Text: true,
    Button: false,
    Image: false,
    Shapes: false,
    Module: false,
    Layers: false,
    Scrollbar: false,
  });

  const getLinkImages = (assetId) => {
    const id = assetId || bannerId || appData?.assetInfo?.assetId;
    if (!id) {
      return;
    }

    const requestId = ++linkImagesRequestRef.current;
    getSaveAssets(id, async (response, err, errorCode) => {
      if (requestId !== linkImagesRequestRef.current) {
        return;
      }

      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        toast.error(<div className="notificationText">{errCoponent}</div>);
        return;
      }

      const data = response?.data;
      setLinkImages(data?.assetLibrary || []);
    });
  };

  const handleOpenElement = (element) => {
    let tempOpenElements = { ...openElements };

    for (let elem in openElements) {
      tempOpenElements[elem] = elem === element ? true : false;
    }
    if (tempOpenElements.Module && showAssettype !== "Banner") {
      return;
    }
    if (toggleAnimatedBanner) {
      setOpenTimeLine(false);
    }
    setOpenElements(tempOpenElements);
    if (element === "Layers" && toggleAnimatedBanner) {
      setOpenTimeLine(true);
    }
  };

  useEffect(() => {
    setSelectedModule(undefined);
    setBgClass(true);
    // Clear previous dimension images immediately so the library doesn't
    // briefly show stale assets while the new dimension list loads.
    setLinkImages([]);
    linkImagesRequestRef.current += 1;

    if (playPauseRef.current.animationCompleted) {
      handleOpenElement("Text");
      setSelectedIndex(0);
    } else if (openElements.Image) {
      getLinkImages(bannerId);
    }
    setIsNext(false);
  }, [bannerId]);
  const handleCloseElement = (element) => {
    setOpenElements({ ...openElements, [element]: false });
  };
  const handleOpenModuleModal = (type) => {
    setOpenModulesModal(true);
    setOpenModulesScreen(true);
  };

  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const checkNotUsedOnEditorModules = (responseClaimsData) => {
    if (notUsedEditorToggle) {
      const claimsNotUsed = responseClaimsData?.claims.filter((claim1) => {
        return !claimsArray.some((claim2) => claim2 === claim1.claimId);
      });
      const reusableTextNotUsed = responseClaimsData.reusableTexts.filter(
        (reusableText) => {
          return !reusableTextIdsArray.some(
            (rtId) => rtId === reusableText.reusableTextId,
          );
        },
      );
      responseClaimsData.components = responseClaimsData.components.map(
        (component) => {
          if (droppedComponentIds.includes(component.componentId)) {
            return {
              ...component,
              componentUrl: "",
            };
          }
          return component;
        },
      );
      responseClaimsData.components = responseClaimsData.components.map(
        (component) => {
          const titleIdUsed = droppedTitleIds.some(
            (id) => id === component.componentId,
          );
          return {
            ...component,
            title: titleIdUsed ? "" : component.title,
          };
        },
      );
      responseClaimsData.components = responseClaimsData.components.map(
        (component) => {
          const relatedTextsFiltered = component.relatedReusableTexts.filter(
            (rt) => !droppedTextIds.includes(rt.id),
          );
          return {
            ...component,
            relatedReusableTexts: relatedTextsFiltered,
          };
        },
      );
      responseClaimsData.components = responseClaimsData.components
        .map((component) => {
          const relatedClaimsFiltered = component.relatedClaims.filter(
            (rtClaim) => !droppedTextIds.includes(rtClaim.id),
          );
          const isEmpty =
            !component.title &&
            relatedClaimsFiltered.length === 0 &&
            !component.componentUrl &&
            component.relatedReusableTexts.length == 0;

          if (isEmpty) {
            return null;
          }
          return {
            ...component,
            relatedClaims: relatedClaimsFiltered,
          };
        })
        .filter((component) => component !== null);
      setModuleClaimsData({
        ...responseClaimsData,
        claims: claimsNotUsed,
        reusableTexts: reusableTextNotUsed,
      });
    } else {
      setModuleClaimsData(responseClaimsData);
    }
  };
  const handleExpandModuleClaims = (card, type) => {
    let moduleTypeID =
      type === "parentModule" ? card?.moduleId : card?.targetModuleId;
    setLoadingModules(true);
    expandClaims(
      moduleTypeID,
      (response, err, errorCode) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
          categoriesErr(errCoponent);
          setLoadingModules(false);
          setModuleClaimsData([]);
        } else {
          let responseClaimsData = response?.data;

          if (responseClaimsData) {
            checkNotUsedOnEditorModules(responseClaimsData);
          }
          setLoadingModules(false);
        }
      },
      linkedModulesType,
    );
  };

  const handleGetChildModules = (moduleId) => {
    setLoadingModules(true);
    getChildModules(moduleId, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        categoriesErr(errCoponent);
        setLoadingModules(false);
        setNoBussinessRules(false);
      } else {
        const businessRules = response?.data?.businessRules;
        let noData = response?.data?.businessRules.length > 0 ? false : true;
        setNoBussinessRules(noData);
        if (!businessRules) {
          setLoadingModules(false);
          return;
        }
        const optionalModules = [];
        const mustExistWithModules = [];

        businessRules.forEach((rule) => {
          switch (rule.ruleCondition) {
            case "Optional":
              if (Array.isArray(rule.targetModules)) {
                rule.targetModules.forEach((module) => {
                  optionalModules.push({
                    ...module,
                    ruleCondition: rule.ruleCondition,
                  });
                });
              }
              break;
            case "MustExistWith":
              rule.targetModules.forEach((module) => {
                mustExistWithModules.push({
                  ...module,
                  ruleCondition: rule.ruleCondition,
                });
              });
              break;

            default:
              break;
          }
        });
        setAssociatedCards((prevState) => ({
          ...prevState,
          [moduleId]: { optionalModules, mustExistWithModules },
        }));
        setLoadingModules(false);
      }
    });
  };
  const mergedData = moduleCardsDataLHS.map((card) => {
    const mlrItem = moduleStatuses.find(
      (item) => item.moduleDamName === card.contentmoduleName
    );

    return {
      ...card,
      mlrStatus: mlrItem ? mlrItem.mlrStatus : null,
    };
  });
  return (
    <>
      <SideBarLeftTopContent
        isOneTimeAsset={isOneTimeAsset}
        setNotUsedEditorToggle={setNotUsedEditorToggle}
        notUsedEditorToggle={notUsedEditorToggle}
        showAssettype={showAssettype}
        handleOpenElement={handleOpenElement}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
        openElements={openElements}
        handleCloseElement={handleCloseElement}
        playPauseRef={playPauseRef}
        bgClass={bgClass}
        setBgClass={setBgClass}
        setIsNext={setIsNext}
        isNext={isNext}
        isModuleExist={isModuleExist}
        getEditSaveAssets={getEditSaveAssets}
        bannerId={bannerId}
        setSelectedModule={setSelectedModule}
      />
      {!isNext && (
        <SideBarLeftPanel
          bannerId={bannerId}
          isOneTimeAsset={isOneTimeAsset}
          isReferenceFootnotes={isReferenceFootnotes}
          isReferenceFootnotesScrollbar={isReferenceFootnotesScrollbar}
          editComponent={editComponent}
          setIsNext={setIsNext}
          bgClass={bgClass}
          setBgClass={setBgClass}
          showBannertype={showBannertype}
          playPauseRef={playPauseRef}
          openTimeLine={openTimeLine}
          showAssettype={showAssettype}
          openTextWindow={openTextWindow}
          setOpenTextWindow={setOpenTextWindow}
          getLayerDetails={getLayerDetails}
          layerCompData={layerCompData}
          openShapesWindow={openShapesWindow}
          setOpenShapesWindow={setOpenShapesWindow}
          setOpenTimeLine={setOpenTimeLine}
          setOpenModuleWindow={setOpenModuleWindow}
          openModuleWindow={openModuleWindow}
          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
          setOpenImageWindow={setOpenImageWindow}
          openImageWindow={openImageWindow}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          layerId={layerId}
          imageOnCanvas={imageOnCanvas}
          linkImages={linkImages}
          setLinkImages={setLinkImages}
          getLinkImages={getLinkImages}
          imageCount={imageCount}
          setImageCount={setImageCount}
          playPause={playPause}
          linkedModulesType={linkedModulesType}
          setLinkedModulesType={setLinkedModulesType}
          loadingModules={loadingModules}
          setLoadingModules={setLoadingModules}
          setVeevaModuleCardData={setVeevaModuleCardData}
          veevaModuleCardData={veevaModuleCardData}
          toggleAnimatedBanner={toggleAnimatedBanner}
          setLayerCompData={setLayerCompData}
          toggleHideComp={toggleHideComp}
          toggleLockComp={toggleLockComp}
          setMultiSelectedComps={setMultiSelectedComps}
          setModules={setModules}
          modules={modules}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
          openElements={openElements}
          handleOpenElement={handleOpenElement}
          handleCloseElement={handleCloseElement}
          setSelectedModulecards={setSelectedModulecards}
          selectedModulecards={selectedModulecards}
          setOpenModulesModal={setOpenModulesModal}
          openModulesScreen={openModulesScreen}
          setOpenModulesScreen={setOpenModulesScreen}
          openModulesModal={openModulesModal}
          handleOpenModuleModal={handleOpenModuleModal}
          showModulesSection={showModulesSection}
          setShowModulesSection={setShowModulesSection}
          setModuleCardsDataLHS={setModuleCardsDataLHS}
          moduleCardsDataLHS={moduleCardsDataLHS}
        />
      )}
      {isNext && selectedModule === undefined && (
        <ModuleCardsWindow
          allMustUseDataEmpty={allMustUseDataEmpty}
          setBannerValidationCheck={setBannerValidationCheck}
          mergedData={mergedData}
          moduleStatuses={moduleStatuses}
          setModuleStatuses={setModuleStatuses}
          undoStack={undoStack}
          redoStack={redoStack}
          setUndoVersion={setUndoVersion}
          undoVersion={undoVersion}
          deleteModulesOnCanvas={deleteModulesOnCanvas}
          setEditModuleClicked={setEditModuleClicked}
          mlrStatuses={mlrStatuses}
          setMlrstatuses={setMlrstatuses}
          setDataGraphichImgDropped={setDataGraphichImgDropped}
          dataGraphichImgDropped={dataGraphichImgDropped}
          selectedModulecards={selectedModulecards}
          selectedModue={selectedModule}
          setSelectedModule={setSelectedModule}
          openModulesModal={openModulesModal}
          setOpenModulesScreen={setOpenModulesScreen}
          setOpenModulesModal={setOpenModulesModal}
          openModulesScreen={openModulesScreen}
          handleOpenModuleModal={handleOpenModuleModal}
          linkedModulesType={linkedModulesType}
          handleExpandModuleClaims={handleExpandModuleClaims}
          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
          showModulesSection={showModulesSection}
          setShowModulesSection={setShowModulesSection}
          handleGetChildModules={handleGetChildModules}
          associatedCards={associatedCards}
          noBussinessRules={noBussinessRules}
          setModuleCardsDataLHS={setModuleCardsDataLHS}
          moduleCardsDataLHS={moduleCardsDataLHS}
          isLoading={isLoading}
          moduleSearchExpression={moduleSearchExpression}
          setModuleSearchExpression={setModuleCardsDataLHS}
        />
      )}

      {selectedModule !== undefined && isNext && (
        <AssociatedModules
          isReferenceFootnotes={
            editComponent ? isReferenceFootnotesScrollbar : isReferenceFootnotes
          }
          reusableTextIdsArray={reusableTextIdsArray}
          claimsArray={claimsArray}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          setModuleClaimsData={setModuleClaimsData}
          moduleClaimsData={moduleClaimsData}
          setNotUsedEditorToggle={setNotUsedEditorToggle}
          notUsedEditorToggle={notUsedEditorToggle}
          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
          isImageDropped={isImageDropped}
          setIsImageDropped={setIsImageDropped}
          setDataGraphichImgDropped={setDataGraphichImgDropped}
          dataGraphichImgDropped={dataGraphichImgDropped}
          droppedComponentIds={droppedComponentIds}
          setDroppedComponentIds={setDroppedComponentIds}
          droppedTextIds={droppedTextIds}
          setDroppedTextIds={setDroppedTextIds}
          droppedTitleIds={droppedTitleIds}
          setDroppedTitleIds={setDroppedTitleIds}
          expandModule={expandModule}
          setExpandModule={setExpandModule}
        />
      )}
      {openModulesModal && (
        <ModulesModal
          setBannerValidationCheck={setBannerValidationCheck}
          setState={setState}
          setRemoveSymbol={setRemoveSymbol}
          setDroppedTextIds={setDroppedTextIds}
          setDroppedComponentIds={setDroppedComponentIds}
          setDroppedTitleIds={setDroppedTitleIds}
          setClaimReferencesFoonotes={setClaimReferencesFoonotes}
          setDroppedComponentTextIds={setDroppedComponentTextIds}
          setScrollClaimReferencesFoonotes={setScrollClaimReferencesFoonotes}
          setClaimsArray={setClaimsArray}
          setLayerCompData={setLayerCompData}
          layerCompData={layerCompData}
          setMlrstatuses={setMlrstatuses}
          mlrStatuses={mlrStatuses}
          selectedChecked={selectedChecked}
          setSelectedChecked={setSelectedChecked}
          openModulesModal={openModulesModal}
          handleOpenModuleModal={handleOpenModuleModal}
          setOpenModulesModal={setOpenModulesModal}
          openModulesScreen={openModulesScreen}
          setOpenModulesScreen={setOpenModulesScreen}
          selectedModulecards={selectedModulecards}
          setSelectedModulecards={setSelectedModulecards}
          setIsNext={setIsNext}
          classes={classes}
          brandName={appData?.genericInfo?.brand}
          countryName={appData?.genericInfo?.market}
          setModuleCardsDataLHS={setModuleCardsDataLHS}
          moduleCardsDataLHS={moduleCardsDataLHS}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleExpandModuleClaims={handleExpandModuleClaims}
          getEditSaveAssets={getEditSaveAssets}
          bannerId={bannerId}
          setModuleSearchExpression={setModuleSearchExpression}
          moduleSearchExpression={moduleSearchExpression}
          setBgClass={setBgClass}
        />
      )}
    </>
  );
};

export default LeftPanel;
